export { default } from './BadgeStar'
